import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 6000 }
  }

  connect() {
    this.dismissed = false
    this.handleBeforeCache = this.handleBeforeCache.bind(this)
    this.handleTransitionEnd = this.handleTransitionEnd.bind(this)

    document.addEventListener("turbo:before-cache", this.handleBeforeCache)

    requestAnimationFrame(() => {
      this.element.classList.remove("opacity-0", "translate-y-2", "sm:translate-x-6")
      this.element.classList.add("opacity-100", "translate-y-0", "sm:translate-x-0")
    })

    this.startTimer(this.delayValue)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.handleBeforeCache)
    this.clearTimer()
  }

  close() {
    this.hide()
  }

  pause() {
    this.clearTimer()
  }

  resume() {
    if (this.dismissed) return
    this.startTimer(this.delayValue)
  }

  hide() {
    if (this.dismissed) return

    this.dismissed = true
    this.clearTimer()

    this.element.classList.remove("opacity-100", "translate-y-0", "sm:translate-x-0")
    this.element.classList.add("opacity-0", "-translate-y-2", "sm:translate-x-6")
    this.element.addEventListener("transitionend", this.handleTransitionEnd, { once: true })

    setTimeout(() => this.removeElement(), 350)
  }

  handleBeforeCache() {
    this.removeElement()
  }

  handleTransitionEnd(event) {
    if (event.target !== this.element) return
    this.removeElement()
  }

  startTimer(duration) {
    this.clearTimer()
    this.timeout = setTimeout(() => this.hide(), duration)
  }

  clearTimer() {
    if (!this.timeout) return
    clearTimeout(this.timeout)
    this.timeout = null
  }

  removeElement() {
    if (!this.element.isConnected) return
    this.element.remove()
  }
}
